import { useLayoutEffect, type ReactElement } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import { Home } from './presentation/pages/home/home'
import { Checkout } from './presentation/pages/checkout/checkout'

export default function Router (): ReactElement {
  const { pathname } = useLocation()

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return <Routes>
    <Route element={<Home />} path="/" />
    <Route element={<Checkout />} path="/checkout" />
  </Routes>
}
